// Feature flags for add-on modules. Billing is sold as a separate add-on service:
// set billing to false for clinics without it — while disabled, its menu item and patient tab show "Coming soon" and /admin/billing redirects to the dashboard.
export const FEATURES = {
  billing: true,
};
